import react, { useRef, useEffect , useState } from "react";
import "../Styles/Service.css";
import { Link } from "react-router-dom";

function Services() {
  return (
    <section className="services-page">
     
      <div className="services-header">
        <h1>Our Services</h1>
        <p>Join us in preserving marine ecosystems for a sustainable future.</p>
      </div>

    
      <div className="services-grid">
{/* card -1 */}
        <Link to="/Service/transmission" className="link">    
            <div className="service-card">
            <img src="/service/Transmission.jpg" alt="TRANSMISSION" />
            <div className="service-content">
                <h3>TRANSMISSION</h3>
                {/* <p>
                The replacement of overhead cables used for electricity or telecommunications with underground cables is the need of the hour. 
                </p> */}
            </div>
            </div>
        </Link>

{/* card -2 */}
        <Link to="/Service/Cable" className="link">    
            <div className="service-card">
            <img src="/service/UndergroundCabling.png" alt="Underground Cabling" />
            <div className="service-content">
                <h3>UNDERGROUND CABLING</h3>
                {/* <p>
                The replacement of overhead cables used for electricity or telecommunications with underground cables is the need of the hour. 
                </p> */}
            </div>
            </div>
        </Link>
 
{/* card -3 */}
           <Link to="/Service/Electric" className="link"> 
        <div className="service-card">
          <img src="/service/RuralElectrification.png" alt="Rural Electrification" />
          <div className="service-content">
            <h3>RURAL ELECTRIFICATION</h3>
            {/* <p>
              Rural electrication is the process of bringing electrical power to rural and remote areas. Rural communities are disconnected from stable power supply due to ineffcient and incomplete power infrastructure.
            </p> */}
          </div>
        </div>
        </Link>

{/* card -4 */}

       <Link to="/Service/Sub" className="link"> 
        <div className="service-card">
          <img src="/service/Substation.png" alt="Substations" />
          <div className="service-content">
            <h3>SUBSTATIONS</h3>
            {/* <p>
              Swastika has developed capability to execute high voltage substations i.e. GIS or AIS up to the highest voltage level. Capability also includes delivery of special substations for Railways.
            </p> */}
          </div>
        </div>
        </Link>

{/* card -5 */}
       <Link to="/Service/Light" className="link"> 
        <div className="service-card">
          <img src="/service/Streetlighting.png" alt="Street Lighting" />
          <div className="service-content">
            <h3>STREET LIGHTING</h3>
            {/* <p>
              As our country is progressing, there is a necessity for illuminating streets, roads and highways for better movement and security of track and personals.
            </p> */}
          </div>
        </div>
        </Link>

      </div>
    </section>
  );
}

export default Services;
